import { render, staticRenderFns } from "./AdminTeam.vue?vue&type=template&id=19e4ae96&"
import script from "./AdminTeam.vue?vue&type=script&lang=js&"
export * from "./AdminTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminTeam.vue"
export default component.exports